import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// King Floyd's — New-customers campaign (adc_hjunzn2z5c). Real lifetime
// aggregates from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (complete months Jul 2025 – Jul 2026). Monthly series lives in realBrandData.ts.
export const campKfNew: FaireAdCampaignEntity = {
  token: "camp_kf_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_king_floyds",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 800,
  startedRunningAt: "2025-07-19",
  segmentMetrics: {
    numCustomersAcquired: 18,
    salesDollars: 7718,
    totalAdsSpendDollars: 2372,
    cpaDollars: 132,
    bestEstimateSalesDollars: 7718,
    bestEstimateRoas: 3.25,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
